<template>
  <el-dialog
    title="答辩详情"
    :visible.sync="visible"
    width="90%"
    :before-close="handleClose"
  >
    <div class="tm_container">
      <table width="100%" cellpadding="5" border="0" class="tm_table_form">
        <tbody>
          <tr>
            <th>批次 :</th>
            <td>{{ config.thesisBatchName }}</td>
          </tr>
          <!-- <tr>
            <th>准考证号 :</th>
            <td>{{ config.candidateNumber }}</td>
          </tr> -->
          <tr>
            <th>姓名 :</th>
            <td>{{ config.studentName }}</td>
          </tr>
          <tr>
            <th>身份证 :</th>
            <td>{{ config.idCardNumber }}</td>
          </tr>
          <tr>
            <th>专业 :</th>
            <td>{{ `${config.specialtyCode}-${config.specialtyName}` }}</td>
          </tr>
          <tr>
            <th>课程 :</th>
            <td>{{ `${config.courseCode}-${config.courseName}` }}</td>
          </tr>
          <tr>
            <th>指导老师 :</th>
            <td>{{ config.teacherName }}</td>
          </tr>
          <tr>
            <th>标题 :</th>
            <td>
              <a
                :href="`https://view.officeapps.live.com/op/view.aspx?src=${config.firstAttPath}`"
                target="_blank"
                v-if="config.firstAttPath&&(config.firstAttPath.endsWith('.doc')||config.firstAttPath.endsWith('.docx'))"
                >{{ config.name }}</a
              >
            </td>
          </tr>
          <tr>
            <th>成绩 :</th>
            <td>
              <template v-if="config.score">
                <template v-if="config.status == 2"> 待生效 </template>
                <template v-if="config.status == 3">
                  {{ config.score }}分
                </template>
              </template>
            </td>
          </tr>
          <tr>
            <th>状态 :</th>
            <td>
              <template v-if="config.status == 0">待上传（待答辩）</template>
              <template v-if="config.status == 1">已上传（已答辩）</template>
              <template v-if="config.status == 2">已打分</template>
              <template v-if="config.status == 3">已生效</template>
            </td>
          </tr>
        </tbody>
      </table>

      <template v-if="config.dbAtt&&config.dbAtt.length">
        <div style="margin-top: 20px; font-size: 15px; text-align: left">
          答辩照片：
          <hr width="80%" style="margin-left: 0px" />
        </div>
        <div id="picListDiv">
          <div v-for="(pic, i) in dbAtt" :key="i">
            <fieldset>
              <legend style="font-size: 14px">
                上传的答辩照片<span>{{ i + 1 }}</span
                >:
              </legend>
              <div style="text-align: center">
                <el-button
                  size="mini"
                  class="tm_btn"
                  type="primary"
                  @click="showOrHide(pic, i)"
                >
                  {{ pic.show ? "展开" : "折叠" }}
                </el-button>
                <div style="margin-top: 5px" v-show="!pic.show">
                  <img
                    :src="pic.attPath"
                    style="max-width: 600px"
                    curRotateIndex="0"
                    id="img_${pic.id}"
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="visible = false"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      config: {},
      dbAtt: [],
    };
  },
  methods: {
    open(res) {
      this.config = res;
      this.dbAtt = res.dbAtt;
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.config = {};
    },
    showOrHide(pic, i) {
      this.$set(pic, "show", !pic.show);
    },
  },
};
</script>

<style scoped>
blockquote,
body,
dd,
div,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
img,
input,
li,
ol,
p,
pre,
td,
th,
ul,
hr,
legend {
  margin: 0;
  padding: 0;
}
</style>
